import React, { useState } from 'react';
import { Link, NavLink, useNavigate, useParams } from 'react-router-dom';

import Radio from "./radio/Radio";

const resources = [
	{
		id: "listen-live",
		title: "Listen Live",
		type: "iframe",
		content: (
			<iframe
				title="Listen Live"
				width="450" height="316"
				frameBorder="0"
				src="https://live365.com/embeds/v1/played/a96984?s=md&m=dark"
			/>
		),
		link: "/radios/listen-live",
	},
	{
		id: "last-played",
		title: "Last Played Songs",
		type: "iframe",
		content: (
			<iframe
				title="Last Played Songs"
				width="450" height="511"
				frameBorder="0"
				src="https://live365.com/embeds/v1/player/a96984?s=md&m=dark&c=mp3"
			/>
		),
		link: "/radios/last-played",
	},
];

const Radios = () => {

	const { id } = useParams();

	var resource = null;
	if (id && id !== '' && (id === 'listen-live' || id === 'last-played')) {
		resource = resources.find(r => r.id === id);
	}

	//logout should be its own component
	const navHistory = useNavigate();

	const [resourceSelected, setResourceSelected] = useState(resource);

	const handleClick = (resource) => {
		if (resource.id === "listen-live" || resource.id === "last-played") {
			setResourceSelected(resource);
		}
	};

	return (
		<div className="body-content bg-fff pt-80l-70m-60s pb-120">

			<div className="panel large ptb-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-libre-baskerville font-size-24l-20m-16s font-weight-800 bb1-555 pb-5">Radio</div>
					</div>
				</div>
			</div>

			<div className="panel large">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-center">
						<table>
							<tbody className="b1-ccc">
								{resources.map((resource, index) => (
									<tr key={index}>
										<td className="font-libre-baskerville font-size-18l-16m font-weight-400 text-left">{resource.title}</td>
										<td className="font-libre-baskerville font-size-18l-16m font-weight-400 text-right">
											{resource.id === "listen-live" ? (
												<Link onClick={() => handleClick(resource)}>Listen</Link>
											) : (
												<Link onClick={() => handleClick(resource)}>View</Link>
											)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<div className="panel large">
				<div className="grid-x pt-20l-10s">
					<div className="large-12 medium-12 small-12 cell text-center">
						{resourceSelected &&
							<>
								<div className="font-raleway font-size-24l-20m-18s font-weight-600 txt-000 text-center line-height-125per">
									{resourceSelected.title}
								</div>
								<Radio resourceId={resourceSelected.id} />
							</>
						}
					</div>

				</div>
			</div>

		</div>
	);
}

export default Radios;